import { StationAccessType } from './station-access-type.model';

export class AccessTypeItem {
  constructor(accessType: StationAccessType, accessTypeText: string) {
    this.AccessType = accessType;
    this.AccessTypeText = accessTypeText;
  }

  AccessType: StationAccessType;
  AccessTypeText: string;
}
